<template>
  <div>
    <div class="bg" style="background-color:#E8E8E8"></div>
    <div class="u-hd" @click="closeModle">
        <div class="hd-bk" >
            <span v-if="!showShare">
                <i class="icon iconback"></i>&nbsp;返回
            </span>
            <span v-else>&nbsp;</span>
        </div>
        <div class="hd-tl">客户集中订货单</div>
        <div class="hd-mu">
            <div style="padding-left:48px"><i class="icon icongengduo2" @click="showShare=true"></i></div>
        </div>
    </div>
    <!-- <van-share-sheet
        v-model="showShare"
        title="立即分享给好友"
        :options="options"
        @select="onSelect"
    /> -->
    <div style="height:44px"></div>
    <div style="display:flex;align-items: center;">
        <div style="padding:5px 10px;" :style="{color:form.state=='NOAUDIT'?'#FF8518':'#4935ae'}">
            <i class="icon icondanju" style="font-size:50px;"></i>
        </div>
        <div style="width:calc(100% - 90px);">
            <div class="add-ord-title">集中订货单 &nbsp;<span style="font-size:12px">({{form.no?form.no:'00000000000'}})</span></div> 
            <div class="add-ord-desc">
                <div>{{form.merchantName}}</div>
            </div>
        </div>
        <div v-if="!showShare" class="btn-share">
            <div style="height: 60px;border-bottom:1px solid #FFF;box-sizing: border-box;padding-top: 6px;" @click="showShareBox=true">
                <div><van-icon name="share-o" size="20"/></div>
                分享
            </div>
            <div  style="height: 60px;background: #ff7907;box-sizing: border-box;padding-top: 6px;" @click="closeModle">
                <div><van-icon name="revoke" size="20"/></div>
                返回
            </div>
        </div>
    </div>
    <div class="share-box" v-if="showShareBox" @click="showShareBox=false">
        <img src="../../assets/images/fx_line.png" class="img-box" alt="" />
        <div class="share-page-tle">
          <div>点击右上角 ... 将它发送给</div>
          <div>指定朋友或分享到朋友圈</div>
          <div style="margin-top:30px">
            <van-button class="login-btn" style="background:rgba(255,255,255,0);border:1px solid #a0a0a0;color:#a0a0a0;width:70%;margin:40px auto;" @click="showShareBox=false"> 我知道了</van-button>
          </div>
        </div>
    </div>
    <div style="background:#fff;margin:0 13px;width:calc(100vw - 25px;);border-top-left-radius:5px;border-top-right-radius:5px;overflow:hidden">
        <!-- <div style="height: calc(100vh - 100px - 143px );overflow-y:auto" v-show="active==0">
            <div style="background-color:#FFF;width: calc(100% - 40px);margin-left:20px;border-radius: 5px;margin-top:15px">
                <div class="form-item" style="background-color: rgba(0,0,0,0);">
                    <div class="form-item-label">要货数量</div>
                    <div class="form-item-value">
                        <div>{{form.stockCount}}</div>
                    </div>
                </div> 
                <div class="form-item" style="background-color: rgba(0,0,0,0);">
                    <div class="form-item-label">制单人</div>
                    <div class="form-item-value">
                        <div>{{form.operatorName}}</div>
                    </div>
                </div>           
                <div class="form-item" style="background-color: rgba(0,0,0,0);">
                    <div class="form-item-label">制单日期</div>
                    <div class="form-item-value">
                        <div>{{form.operatorTime}}</div>
                    </div>
                </div> 
                <div class="form-item" style="background-color: rgba(0,0,0,0);">
                    <div class="form-item-label">备注</div>
                    <div class="form-item-value">
                        <div>{{form.remark}}</div>
                    </div>
                </div> 
            </div>
        </div> -->
        <div>
            <detali-table :isShow="isShow" :order="form" :details="details" bindchangeTable="changeState"></detali-table>
        </div>
    </div>
    <!-- <div class="fixed-submit" style="width:calc(100vw - 25px);left:13px">
        <div style="background-color:#486ad8;width:calc(100% - 100px);display: flex;" v-if="form.sendState=='0'">
            <div  class="btn" style="flex:2" @click="save" data-type="AUDIT">
                <i class="icon iconbaocun"></i>
                <div class="btn-text">收到</div>
            </div>
        </div>
        <div style="width:100px;background-color:#ff8518;display:flex" @click="goBack">
            <div class="btn" >
                <i class="icon iconfanhui1"></i>
                <div class="btn-text">返回</div>
            </div>
        </div>
    </div> -->
  </div>
</template>

<script>
import { Toast } from 'vant';
import detailsTableFoucs from './detailsTableFocus';
export default {
    components:{
        'detali-table':detailsTableFoucs
    },
    data() {
        return {
            form: {},
            details: [],
            active: 0,
            showShareBox:false,
            showBatchNoModel: false,
            state: 1,
            isShow: false,
            showPreOrderModel: false,
            moreKey: {},
            typeList: [],
            priceSetting: '',
            planappoint: '',
            plantype: '',
            planladder: '',
            showShare:false,
            account:JSON.parse(window.localStorage.getItem("account")),
            options: [
                { name: '微信', icon: 'wechat' },
                { name: '导出', icon: 'qrcode' },
            ],
            plandiscount: ''
        }
    },
    created(){
         if(this.account.share){
            this.$request.get("purchaseOrder/focusOrderDetailShare?orderId="+this.account.orderId+"&accessKey="+localStorage.getItem('accessKey') ).then(data=>{
                this.form=data.content.order
                this.details=data.content.details
            })
            this.showShare=true
        }else{
            this.$request.get("purchaseOrder/focusOrderDetails?orderId="+this.$route.query.orderId).then(data=>{
                this.form=data.content.order
                this.details=data.content.details
                if(this.form.sendState=='0'){
                    this.save()
                }
            })
        }
        
        this.$request.getApi("index/wxJsInit?accessKey=" + window.localStorage.getItem("accessKey")+"&dir="+encodeURIComponent(window.location.href.split('#')[0])+"&appId="+window.localStorage.getItem("appId")).then(data => {
            if(data.status==200){
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: data.content.appId, // 必填，公众号的唯一标识
                    timestamp: data.content.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.content.nonceStr, // 必填，生成签名的随机串
                    signature: data.content.signature, // 必填，签名
                    jsApiList: ['updateAppMessageShareData'] // 必填，需要使用的JS接口列表
                });
                wx.ready(function(){
                    wx.updateAppMessageShareData({ 
                        title: '客户集中订货单', // 分享标题
                        desc: '点击查看订货详情', // 分享描述
                        link: window.location.href+'&share=1&accessKey='+window.localStorage.getItem('accessKey')+'&appId='+window.localStorage.getItem('appId'), // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                        imgUrl: '', // 分享图标
                        success: function () {
                        // 设置成功
                        }
                    })
                })
            }else if(data.status==40100){
            }
        }).catch(err => {
        })
    },
    methods:{
        changeTab(name, title) {
            this.active=name
        },
        goBack(){
            this.router.go(-1)
        },
        save() {
            this.$request.post("purchaseOrder/handleFocusOrder", {orderId:this.$route.query.orderId}).then(data => {
                if (data.status == 200) {
                    Toast("处理成功")
                    this.$request.get("purchaseOrder/orderDetail?orderId="+this.$route.query.orderId).then(data=>{
                        this.form=data.content.order
                        this.details=data.content.detailList
                    })
                } else {
                    wx.showToast({
                        icon: 'none',
                        title: data.message
                    })
                }
            })
        },
        closeModle(){
            this.router.go(-1)
        }
    }
}
</script>

<style scoped>

.add-ord-title{
    font-size: 16px;
    padding-bottom:5px;
    border-bottom:1px solid #ccc
}

.add-ord-desc{
    font-size:15px;
}
.order-price{
    color:#F56C6C;
    font-weight: 600
}


.add-tabs{
    font-size:15px !important;
    font-weight:700
}



.model-bg {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 1;
    height: calc(100vh - 65px);
    width: 50vw;
    background-color: rgba(0, 0, 0, 0.78);
  }
  .sub-btn{
    width: 60px;
    color:#FFF;
    background-color: rgb(73, 53, 174);
    text-align: center;
    height: 60px;
    margin-left: 25px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    right: 30px;
    bottom: 40px;
    z-index: 10;
  }
  .btn-share{
    position: fixed;
    right: 12px;
    bottom: 22px;
    width: 50px;
    background-color: #4C37B6;
    color: #FFF;
    text-align: center;
    z-index: 10;
    font-size: 12px;
}
.share-box{
    width:100vw;
    height:100vh;
    background:rgba(0,0,0,0.9);
    z-index:25;
    position:fixed;
    top:0px;
    left:0px
}

.img-box{
width:120px;
height:auto;
position:fixed;
top:5px;
right:20px;
}
.share-page-tle{
color:#fff;
position: fixed;
top:130px;
right:0px;
width:100vw;
text-align: center;
font-size:14px;
}

.share-page-tle div{
padding:3px 0;
font-size:13px;
font-weight: 400;
/* font-family: PingFang SC; */
}
</style>


// WEBPACK FOOTER //
// src/views/purchaseOrder/detailFocus.vue